import { BaseService } from '@common/http-layer/service/base.service'
import { useLocation } from '@common/location-layer/composables/useLocation'

export class ProductLearnerService extends BaseService {
  constructor() {
    super({
      baseURL: 'REST_API_URLS',
      basePath: '',
      headers: {
        version: '2021-07-28',
      },
    })
  }

  private endpoint(path: string = '', locationId?: string): string {
    const { store: state } = useLocation()
    if (!state.locationId) throw new Error('Location ID is required')
    return `/courses/learners/locations/${locationId ? locationId : state.locationId}/courses${path}`
  }

  async getProductById(params: { courseId: string; locationId: string }) {
    const { data } = await this.get(this.endpoint(`/${params.courseId}`, params.locationId), {
      productId: params.courseId,
      locationId: params.locationId,
    })
    return data
  }

  async checkProductAccess(params: { courseId: string; source: string; locationId: string }) {
    const { data } = await this.get(this.endpoint(`/${params.courseId}/access?source=${params.source}`, params.locationId), {
      productId: params.courseId,
      locationId: params.locationId,
    })
    return data
  }

  async getBasicProductInfo(params: { courseId: string; locationId: string }) {
    const { data } = await this.get(this.endpoint(`/${params.courseId}/resolve`, params.locationId), {
      productId: params.courseId,
      locationId: params.locationId,
    })
    return data
  }
}
